var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        {
          staticClass: "text-center",
          attrs: { "data-cy": "FormCandidate-form" },
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-select", {
                            attrs: {
                              dense: "",
                              filled: "",
                              items: ["Mr", "Mrs"],
                              label: _vm.$$t("salutation"),
                            },
                            model: {
                              value: _vm.localCandidate.salutation,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "salutation", $$v)
                              },
                              expression: "localCandidate.salutation",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "8" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              filled: "",
                              dense: "",
                              "data-cy": "FormCandidate-name",
                              label: _vm.$$t("name"),
                            },
                            model: {
                              value: _vm.localCandidate.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "name", $$v)
                              },
                              expression: "localCandidate.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              "data-cy": "FormCandidate-email",
                              label: _vm.$$t("email"),
                            },
                            model: {
                              value: _vm.localCandidate.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "email", $$v)
                              },
                              expression: "localCandidate.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              "data-cy": "FormCandidate-phone",
                              label: _vm.$$t("phone"),
                            },
                            model: {
                              value: _vm.localCandidate.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "phone", $$v)
                              },
                              expression: "localCandidate.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              filled: "",
                              "data-cy": "FormCandidate-dateOfBirth",
                              label: _vm.$$t("dateOfBirth"),
                            },
                            model: {
                              value: _vm.localCandidate.dateOfBirth,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "dateOfBirth", $$v)
                              },
                              expression: "localCandidate.dateOfBirth",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              filled: "",
                              items: ["Not Say", "Male", "Female"],
                              label: _vm.$$t("gender"),
                            },
                            model: {
                              value: _vm.localCandidate.gender,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "gender", $$v)
                              },
                              expression: "localCandidate.gender",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              filled: "",
                              "data-cy": "FormCandidate-currentEmployer",
                              label: _vm.$$t("currentEmployer"),
                            },
                            model: {
                              value: _vm.localCandidate.currentEmployer,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localCandidate,
                                  "currentEmployer",
                                  $$v
                                )
                              },
                              expression: "localCandidate.currentEmployer",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              filled: "",
                              "data-cy": "FormCandidate-title",
                              label: _vm.$$t("title"),
                            },
                            model: {
                              value: _vm.localCandidate.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "title", $$v)
                              },
                              expression: "localCandidate.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              "data-cy": "FormCandidate-linkedInUrl",
                              label: _vm.$$t("linkedInUrl"),
                              "append-icon": _vm.localCandidate.linkedInUrl
                                ? _vm.mdiOpenInNew
                                : "",
                            },
                            on: { "click:append": _vm.openLinkedIn },
                            model: {
                              value: _vm.localCandidate.linkedInUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "linkedInUrl", $$v)
                              },
                              expression: "localCandidate.linkedInUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              "data-cy": "FormCandidate-location",
                              label: _vm.$$t("location"),
                            },
                            model: {
                              value: _vm.localCandidate.location,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "location", $$v)
                              },
                              expression: "localCandidate.location",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              "data-cy": "FormCandidate-country",
                              label: _vm.$$t("country"),
                            },
                            model: {
                              value: _vm.localCandidate.country,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "country", $$v)
                              },
                              expression: "localCandidate.country",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-select", {
                            attrs: {
                              dense: "",
                              filled: "",
                              items: _vm.industries,
                              "item-text": "name",
                              "item-value": "id",
                              label: _vm.$$t("industryId"),
                            },
                            model: {
                              value: _vm.localCandidate.industryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "industryId", $$v)
                              },
                              expression: "localCandidate.industryId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              dense: "",
                              filled: "",
                              label: _vm.$$t("createdBy"),
                            },
                            model: {
                              value: _vm.localCandidate.createdBy,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "createdBy", $$v)
                              },
                              expression: "localCandidate.createdBy",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _vm.localCandidate.imageUrl
                    ? _c("v-img", {
                        attrs: {
                          contain: "",
                          src: _vm.localCandidate.imageUrl,
                          "max-height": _vm.$vuetify.breakpoint.mobile
                            ? 200
                            : 380,
                        },
                      })
                    : _vm._e(),
                  _c("ImageUpload", {
                    attrs: {
                      label: "Upload Profile Picture",
                      hint: "Drag and drop the candidate profile here",
                    },
                    on: {
                      url: function ($event) {
                        _vm.localCandidate.imageUrl = $event
                      },
                    },
                    model: {
                      value: _vm.localCandidate.imageUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.localCandidate, "imageUrl", $$v)
                      },
                      expression: "localCandidate.imageUrl",
                    },
                  }),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-checkbox", {
                            attrs: { label: "Newsletter" },
                            model: {
                              value: _vm.localCandidate.newsLetter,
                              callback: function ($$v) {
                                _vm.$set(_vm.localCandidate, "newsLetter", $$v)
                              },
                              expression: "localCandidate.newsLetter",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "8" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: ["English", "French", "German", "Italian"],
                              label: "Language",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.localCandidate.id
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("div", { staticClass: "text-h5 text-left" }, [
                                _vm._v("Comments"),
                              ]),
                              _c("CandidateComments", {
                                attrs: { candidateId: _vm.localCandidate.id },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("div", { staticClass: "text-h5 text-left" }, [
                                _vm._v("Documents"),
                              ]),
                              _c("CandidateDocuments", {
                                attrs: { candidateId: _vm.localCandidate.id },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("div", { staticClass: "text-h5 text-left" }, [
                                _vm._v("Candidate History"),
                              ]),
                              _c("CandidateFeed", {
                                attrs: { candidateId: _vm.localCandidate.id },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6 mt-5" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormCandidate-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isSaving,
                    "data-cy": "FormCandidate-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }